const MainFrame = ({main_image}) => {
  return (
    <div className="mainframe">
        <img src={main_image} alt="main_image" />
    </div>
  )
}

export default MainFrame